<div class="h-full flex flex-col overflow-hidden">
  <ng-container *ngIf="!isLoading">
    <mat-card class="p-4 rounded-2xl bg-[var(--main)] z-10">
      <div class="flex items-center gap-2">
        <h5 class="flex-1 font-semibold">
          <span *ngIf="!isDeletePreviewMode">
            {{ mouvement.mouvement_ID === 0 ? "Création d'un mouvement" :
            "Modification d'un mouvement" }}
          </span>
          <span *ngIf="isDeletePreviewMode">
            Prévisualisation de la suppression
          </span>
        </h5>
        <div class="flex items-center gap-2">
          <button
            *ngIf="!isDeletePreviewMode"
            class="btn-fab txt-primary"
            (click)="postMouvement()"
            matTooltip="Enregistrer"
          >
            <mat-icon>save</mat-icon>
          </button>
          <button
            *ngIf="isDeletePreviewMode"
            class="btn-fab txt-danger"
            (click)="confirmDelete()"
            matTooltip="Confirmer la suppression"
          >
            <mat-icon>check</mat-icon>
          </button>
          <button
            *ngIf="!isDeletePreviewMode && isEditMode && isTodoMouvement"
            class="btn-fab txt-success"
            (click)="actionnerMouvement()"
            matTooltip="Actionner le mouvement"
          >
            <mat-icon>play_arrow</mat-icon>
          </button>
          <button
            *ngIf="!isDeletePreviewMode && isEditMode"
            class="btn-fab txt-danger"
            (click)="deleteMouvement()"
            matTooltip="Supprimer"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button class="btn-fab" (click)="close()" matTooltip="Fermer">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>

    <div
      class="flex-1 p-4 bg-[var(--main-light)]"
      [class.overflow-auto]="!isDeletePreviewMode"
      [style.max-height]="!isDeletePreviewMode ? 'calc(100dvh - 200px)' : 'none'"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Colonne Gauche: Formulaire -->
        <div *ngIf="!isDeletePreviewMode" class="h-full flex flex-col gap-4">
          <mat-card class="p-4 bg-[var(--main-card)] flex-1">
            <h6 class="font-semibold mb-4">Informations du mouvement</h6>

            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Type de mouvement</mat-label>
              <mat-select
                [(ngModel)]="mouvement.mouvement_Type"
                (ngModelChange)="onTypeChange()"
                [disabled]="isEditMode"
                [ngModelOptions]="{standalone: true}"
              >
                <mat-option
                  *ngFor="let type of typesOptions"
                  [value]="type.value"
                >
                  {{ type.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <select-date
              [(value)]="mouvement.mouvement_Date"
              title="Date"
              [disabled]="isEditMode"
              (valueChange)="checkAndGeneratePreview()"
            ></select-date>

            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Nature</mat-label>
              <input
                matInput
                [(ngModel)]="mouvement.mouvement_Nature"
                placeholder="Description du mouvement"
                [ngModelOptions]="{standalone: true}"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Nombre d'actions</mat-label>
              <input
                matInput
                type="number"
                inputnumber="ENTIER"
                [(ngModel)]="mouvement.mouvement_Valeur"
                (blur)="onValeurChange()"
                [ngModelOptions]="{standalone: true}"
              />
            </mat-form-field>
          </mat-card>

          <mat-card class="p-4" *ngIf="!isFromActionnaireDialog">
            <h6 class="font-semibold mb-4">Actionnaire concerné</h6>

            <select-actionnaire
              [(ngModel)]="mouvement.actionnaire_ID"
              (ngModelChange)="onActionnaireChange($event)"
            ></select-actionnaire>
          </mat-card>

          <mat-card class="p-4">
            <h6 class="font-semibold mb-4">Destinataire</h6>

            <mat-radio-group
              [value]="mouvement.mouvement_Origine"
              (change)="onOrigineChange($event.value)"
              class="flex flex-col gap-2 mb-4"
              [disabled]="isEditMode"
            >
              <mat-radio-button
                [value]="1"
                [disabled]="!isSocieteAllowed || isEditMode"
              >
                Auprès de la société
              </mat-radio-button>
              <mat-radio-button [value]="0" [disabled]="isEditMode">
                Auprès d'un autre actionnaire
              </mat-radio-button>
            </mat-radio-group>

            <select-actionnaire
              *ngIf="needsSecondActionnaire"
              [(ngModel)]="mouvement.from_ID"
              (ngModelChange)="onFromChange($event)"
              (selectionChange)="onCounterpartySelectionChange($event)"
            ></select-actionnaire>
          </mat-card>
        </div>

        <!-- Colonne Droite: Aperçu -->
        <div
          class="h-full flex flex-col gap-4"
          [class.col-span-2]="isDeletePreviewMode"
        >
          <mat-card
            class="p-4 bg-[var(--main-card)] flex-1"
            *ngIf="(showPreview && preview) || (isDeletePreviewMode && preview)"
          >
            <h6 class="font-semibold mb-4">
              {{ isDeletePreviewMode ? "Aperçu après suppression" : "Aperçu du
              mouvement" }}
            </h6>

            <div *ngIf="!preview.isValid" class="alert alert-error p-4 mb-4">
              <div class="flex items-center gap-2">
                <mat-icon>error</mat-icon>
                <div class="flex-1">
                  {{ preview.errorMessage || "Une erreur est survenue lors de la
                  prévisualisation" }}
                </div>
              </div>
            </div>

            <div *ngIf="preview.isValid" class="space-y-4 text-[var(--text)]">
              <!-- Actionnaire 1 -->
              <div
                class="border border-[var(--border)] rounded-lg p-4 flex-1 bg-[var(--main-light)]"
              >
                <h6 class="font-semibold text-sm mb-3">
                  {{ preview.actionnaire1.actionnaire_Prenom }} {{
                  preview.actionnaire1.actionnaire_Nom }}
                </h6>

                <div class="flex flex-col text-sm">
                  <div class="border-t border-[var(--border)] py-2">
                    <div class="flex items-center gap-2">
                      <div
                        class="font-medium text-[var(--text-lightest)] flex-1"
                      >
                        PP
                      </div>
                      <span class="text-[var(--text-light)] flex-1"
                        >{{ preview.actionnaire1.pP_Avant }}</span
                      >
                      <mat-icon class="text-sm flex-1">arrow_forward</mat-icon>
                      <span
                        class="font-semibold flex-1"
                        [class.text-green-600]="
                          preview.actionnaire1.pP_Apres >
                          preview.actionnaire1.pP_Avant
                        "
                        [class.text-red-600]="
                          preview.actionnaire1.pP_Apres <
                          preview.actionnaire1.pP_Avant
                        "
                        >{{ preview.actionnaire1.pP_Apres }}</span
                      >
                    </div>
                  </div>

                  <div class="border-t border-[var(--border)] py-2">
                    <div class="flex items-center gap-2">
                      <div
                        class="font-medium text-[var(--text-lightest)] flex-1"
                      >
                        NP
                      </div>
                      <span class="text-[var(--text-light)] flex-1"
                        >{{ preview.actionnaire1.nP_Avant }}</span
                      >
                      <mat-icon class="text-sm flex-1">arrow_forward</mat-icon>
                      <span
                        class="font-semibold flex-1"
                        [class.text-green-600]="
                          preview.actionnaire1.nP_Apres >
                          preview.actionnaire1.nP_Avant
                        "
                        [class.text-red-600]="
                          preview.actionnaire1.nP_Apres <
                          preview.actionnaire1.nP_Avant
                        "
                        >{{ preview.actionnaire1.nP_Apres }}</span
                      >
                    </div>
                  </div>

                  <div class="border-t border-[var(--border)] py-2">
                    <div class="flex items-center gap-2">
                      <div
                        class="font-medium text-[var(--text-lightest)] flex-1"
                      >
                        US
                      </div>
                      <span class="text-[var(--text-light)] flex-1"
                        >{{ preview.actionnaire1.uS_Avant }}</span
                      >
                      <mat-icon class="text-sm flex-1">arrow_forward</mat-icon>
                      <span
                        class="font-semibold flex-1"
                        [class.text-green-600]="
                          preview.actionnaire1.uS_Apres >
                          preview.actionnaire1.uS_Avant
                        "
                        [class.text-red-600]="
                          preview.actionnaire1.uS_Apres <
                          preview.actionnaire1.uS_Avant
                        "
                        >{{ preview.actionnaire1.uS_Apres }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="flex items-center justify-center text-[var(--text)] rotate-90"
              >
                <mat-icon>sync_alt</mat-icon>
              </div>

              <!-- Actionnaire 2 -->
              <div
                *ngIf="preview.actionnaire2"
                class="border border-[var(--border)] rounded-lg p-4 flex-1 bg-[var(--main-light)]"
              >
                <h6 class="font-semibold text-sm mb-3">
                  {{ preview.actionnaire2.actionnaire_Prenom }} {{
                  preview.actionnaire2.actionnaire_Nom }}
                </h6>

                <div class="flex flex-col text-sm">
                  <div class="border-t border-[var(--border)] py-2">
                    <div class="flex items-center gap-2">
                      <div
                        class="font-medium text-[var(--text-lightest)] flex-1"
                      >
                        PP
                      </div>
                      <span class="text-[var(--text-light)] flex-1"
                        >{{ preview.actionnaire2.pP_Avant }}</span
                      >
                      <mat-icon class="text-sm flex-1">arrow_forward</mat-icon>
                      <span
                        class="font-semibold flex-1"
                        [class.text-green-600]="
                          preview.actionnaire2.pP_Apres >
                          preview.actionnaire2.pP_Avant
                        "
                        [class.text-red-600]="
                          preview.actionnaire2.pP_Apres <
                          preview.actionnaire2.pP_Avant
                        "
                        >{{ preview.actionnaire2.pP_Apres }}</span
                      >
                    </div>
                  </div>

                  <div class="border-t border-[var(--border)] py-2">
                    <div class="flex items-center gap-2">
                      <div
                        class="font-medium text-[var(--text-lightest)] flex-1"
                      >
                        NP
                      </div>
                      <span class="text-[var(--text-light)] flex-1"
                        >{{ preview.actionnaire2.nP_Avant }}</span
                      >
                      <mat-icon class="text-sm flex-1">arrow_forward</mat-icon>
                      <span
                        class="font-semibold flex-1"
                        [class.text-green-600]="
                          preview.actionnaire2.nP_Apres >
                          preview.actionnaire2.nP_Avant
                        "
                        [class.text-red-600]="
                          preview.actionnaire2.nP_Apres <
                          preview.actionnaire2.nP_Avant
                        "
                        >{{ preview.actionnaire2.nP_Apres }}</span
                      >
                    </div>
                  </div>

                  <div class="border-t border-[var(--border)] py-2">
                    <div class="flex items-center gap-2">
                      <div
                        class="font-medium text-[var(--text-lightest)] flex-1"
                      >
                        US
                      </div>
                      <span class="text-[var(--text-light)] flex-1"
                        >{{ preview.actionnaire2.uS_Avant }}</span
                      >
                      <mat-icon class="text-sm flex-1">arrow_forward</mat-icon>
                      <span
                        class="font-semibold flex-1"
                        [class.text-green-600]="
                          preview.actionnaire2.uS_Apres >
                          preview.actionnaire2.uS_Avant
                        "
                        [class.text-red-600]="
                          preview.actionnaire2.uS_Apres <
                          preview.actionnaire2.uS_Avant
                        "
                        >{{ preview.actionnaire2.uS_Apres }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- Société -->
              <div
                *ngIf="preview.societe"
                class="border border-[var(--border)] rounded-lg p-4 flex-1 bg-[var(--main-light)]"
              >
                <h6 class="font-semibold text-sm mb-3">Société</h6>

                <div class="border-t border-[var(--border)] py-2 text-sm">
                  <div class="flex items-center gap-2">
                    <div class="font-medium text-[var(--text-lightest)] flex-1">
                      Dispo
                    </div>
                    <span class="text-[var(--text-light)] flex-1"
                      >{{ preview.societe.societe_NbPart_Avant }}</span
                    >
                    <mat-icon class="text-sm flex-1">arrow_forward</mat-icon>
                    <span
                      class="font-semibold flex-1"
                      [class.text-green-600]="
                        preview.societe.societe_NbPart_Apres >
                        preview.societe.societe_NbPart_Avant
                      "
                      [class.text-red-600]="
                        preview.societe.societe_NbPart_Apres <
                        preview.societe.societe_NbPart_Avant
                      "
                      >{{ preview.societe.societe_NbPart_Apres }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </mat-card>

          <div
            *ngIf="!showPreview && !isDeletePreviewMode"
            class="flex-1 flex items-center justify-center text-[var(--text-light)]"
          >
            <div class="text-center">
              <mat-icon
                class="mb-2"
                style="height: 64px; width: 64px; font-size: 64px"
                >cancel</mat-icon
              >
              <p>Aucun mouvement d'action détecté</p>
            </div>
          </div>

          <!-- Mouvement futur -->
          <mat-card
            class="p-4 bg-[var(--main-card)]"
            *ngIf="!isDeletePreviewMode"
          >
            <h6 class="font-semibold mb-4">Mouvement futur</h6>
            <div class="flex flex-col gap-4">
              <mat-checkbox
                [(ngModel)]="isTodoMouvement"
                (ngModelChange)="onTodoChange()"
                [ngModelOptions]="{standalone: true}"
              >
                Effectuer le mouvement dans le futur
              </mat-checkbox>
              <select-date
                *ngIf="isTodoMouvement"
                [(value)]="mouvement.mouvement_DateTODO"
                title="Date prévue"
                (valueChange)="checkAndGeneratePreview()"
              ></select-date>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div class="flex-1 flex items-center justify-center p-4">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-container>
</div>
